import { useEffect } from "react"

import { useNavigate, useSearchParams } from "react-router-dom"
import {
  useShopifyCart,
  updateDiscountCode
} from "~/providers/ShopifyCartProvider"
import { useShopifyClient } from "~/providers/ShopifyClientProvider"

const ApplyDiscount: React.FC = () => {
  const [searchParams] = useSearchParams()

  const { ensureCheckoutIsCreated, loading } = useShopifyCart()

  const shopify = useShopifyClient()

  const navigate = useNavigate()

  useEffect(() => {
    const code = searchParams.get("code")

    if (loading || !code || code.length === 0) return

    const asyncFunction = async () => {
      const checkoutId = await ensureCheckoutIsCreated()
      await updateDiscountCode(shopify, checkoutId, code)
      navigate(window.location.pathname, { replace: true })
    }
    asyncFunction()
  }, [loading, shopify, searchParams, ensureCheckoutIsCreated, navigate])

  return <></>
}

export default ApplyDiscount
